<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-07 11:04:59
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:27:40
-->
<template>
  <div>
    <!--    @click:row='rowgodetail' -->
    <mrc_ess_table
      v-if="$route.name == 'valueIntconfig'"
      :headers="headers"
      hideAddBtn
      :slotKey="['table_description', 'module_name']"
      :paginationOptions="options"
      @turnPage="getlist"
      :isLoading="loading"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="
            background: white;
            margin: 0;
            border-top-right-radius: 8px;
            border-top-left-radius: 8px;
            padding: 0 16px;
          "
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <!-- 模块 -->
      <template v-slot:item.module_name="{ item }">
        <span class="text-no-wrap">
          {{ INT(item.module_name) }}
        </span>
      </template>
      <!-- 表格 -->
      <template v-slot:item.table_description="{ item }">
        <mrc_ess_chip
          small
          class="mr-1 my-1"
          v-for="(item1, index1) in item.table_description"
          :key="index1"
        >
          {{ item1 }}
        </mrc_ess_chip>
      </template>

      <!-- 按钮 -->
      <template v-slot:item.actions="{ item }">
        <menu-list
          :list="menulist"
          v-btnAuth="[
            'edit-value-internationalization-configuration',
            'view-value-internationalization-configuration',
          ]"
          @handleClick="handleClick($event, item)"
        >
          <template v-slot:showAction>
            <v-icon>mdi-dots-vertical</v-icon>
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { valuelist } from "@/service/api/internationalization.js";

export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      loading: false,
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      desserts: [],
    };
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1);
  },
  async created() {
    await this.getBtnPermissionList();
  },
  async mounted() {
    await this.getlist();
  },
  beforeDestroy() {},
  methods: {
    rowgodetail(item) {
      this.$store.commit("set_iconstatus", true); //行内进图标显示
      this.$store.commit("set_uuid", item.module_uuid); //
      this.$store.commit("set_subPage_name", item.module_name); //
      this.$router.push({
        name: "detailvalueIntconfig",
        params: { title: item.module_name },
      });
    },
    handleClick({ index }, item) {
      switch (index) {
        case 0:
          this.rowgodetail(item);
          break;
        case 1:
          this.$store.commit("set_iconstatus", false); //行内进图标显示
          this.$store.commit("set_uuid", item.module_uuid); //
          this.$store.commit("set_subPage_name", item.module_name); //
          this.$router.push({
            name: "detailvalueIntconfig",
            params: { title: item.module_name },
          });
          break;
      }
    },
    goadd() {
      this.$store.commit("set_iconstatus", ""); //行内进图标显示
      this.$store.commit("set_uuid", ""); //
      this.$store.commit("set_subPage_name", ""); //
      this.$router.push({
        name: "addpromptmanagement",
      });
    },
    async getlist(obj) {
      this.loading = true;
      // if (this.desserts.length == 1 && this.options.cpage != 1) this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj;

        this.options = { ...this.options, ...obj };
      }
      const res = await valuelist({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      });
      if (res.code == 200) {
        this.options.totalcount = res.totalcount;
        this.options.totalpage = res.totalpage;
        this.desserts = res.data.map((item) => {
          if (item.table_description) {
            item.table_description =
              item.table_description.indexOf(",") != -1
                ? item.table_description.split(",")
                : [item.table_description];
            return item;
          } else {
            return item;
          }
        });
        this.systemFieldMeta = res.systemFieldMeta;
        this.field_alias_name = res.field_alias_name;
        this.table_alias_name = res.table_alias_name;
      }
      this.loading = false;
      // this.desserts = this.desserts.map(item => {
      //   item.table_description = (item.table_description.indexOf(',') != -1) ? item.table_description.split(',') : [item.table_description];
      //   return item
      // })
    },
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_The_module"),
          align: "start",
          sortable: false,
          value: "module_name",
        },
        {
          text: this.$t("label_form"),
          align: "start",
          sortable: false,
          value: "table_description",
        },
        {
          text: "",
          width: "50",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ];
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-value-internationalization-configuration"),
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-value-internationalization-configuration"),
        },
      ];
    },
  },
  watch: {
    $route(v) {
      if (v.name == "valueIntconfig") {
        this.getlist();
      }
    },
  },
};
</script>

<style scoped></style>
